import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TextLink, Text } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

export default class RecommendedJobsDashboard extends PureComponent {
  static propTypes = {
    dataAutomation: PropTypes.string,
    navLinkProps: PropTypes.shape({
      analytics: PropTypes.string,
      location: PropTypes.string
    }).isRequired,
    retryHandler: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired
  };

  render() {
    const { dataAutomation, navLinkProps, retryHandler, label } = this.props;

    return (
      <Text data-automation={dataAutomation} secondary small>
        The {label} summary is currently unavailable. Please{' '}
        <TextLink onClick={retryHandler}>retry</TextLink>, or go to the&nbsp;
        <NavLink component={TextLink} {...navLinkProps}>
          {label} page
        </NavLink>
        .
      </Text>
    );
  }
}
